import { apiClient } from './apiClient';

export interface SystemSettings {
  company_name?: string;
  company_short_name?: string;
  system_name?: string;
  system_subtitle?: string;
  primary_color?: string;
  [key: string]: string | undefined;
}

export const systemSettingsService = {
  async get(): Promise<SystemSettings> {
    const { data } = await apiClient.get<SystemSettings>('/system/settings');
    return data;
  },

  async update(settings: Partial<SystemSettings>): Promise<void> {
    await apiClient.patch('/system/settings', { settings });
  },

  async uploadLogo(file: File): Promise<void> {
    const form = new FormData();
    form.append('file', file);
    await apiClient.post('/system/logo', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  async deleteLogo(): Promise<void> {
    await apiClient.delete('/system/logo');
  },

  logoUrl(bustCache = false): string {
    const bust = bustCache ? `?t=${Date.now()}` : '';
    return `/api/system/logo${bust}`;
  },
};

// Default values — dùng khi API chưa load xong hoặc offline
export const DEFAULT_SETTINGS: SystemSettings = {
  company_name: 'Bệnh viện Hưng Việt',
  company_short_name: 'HV',
  system_name: 'HV-TaskFlow',
  system_subtitle: 'Hệ thống quản lý công việc & ký điện tử',
  primary_color: '#1976D2',
  primary_color_dark: '#0F4C81',
  // Logo display mode: 'image' (dùng logo upload) hoặc 'text' (dùng company_short_name)
  logo_display_mode: 'image',
  // Login
  login_title: 'ĐĂNG NHẬP HỆ THỐNG',
  login_description: 'Nhập tên đăng nhập và mật khẩu được cấp bởi quản trị viên.',
  login_brand_subtitle: 'Cổng thông tin nội bộ',
  login_brand_caption: 'Quản lý công việc & ký điện tử',
  // Liên hệ
  company_address: '34 Đại Cồ Việt, Hai Bà Trưng, Hà Nội',
  company_hotline: '(024) 3974 7777',
  copyright_text: 'Copyright © 2026 Bệnh viện Hưng Việt',
  // Menu
  menu_bg_color: '#1F2937',
  menu_text_color: '#E5E7EB',
  menu_active_color: '#1976D2',
  // Font
  font_family: 'Inter, system-ui, -apple-system, sans-serif',
  font_size_base: '14',
  // V1.0.28: Kích thước khung chữ ký trong phiếu (system-wide config)
  signature_box_height: '55',
  signature_box_width: '180',
  // V1.0.29: Labels cho ma trận Eisenhower — admin config được
  eis_q1_title: 'Q1 — QUAN TRỌNG VÀ KHẨN CẤP',
  eis_q1_subtitle: 'Ưu tiên thực hiện ngay',
  eis_q1_short: 'Quan trọng & Khẩn cấp',
  eis_q2_title: 'Q2 — QUAN TRỌNG NHƯNG KHÔNG KHẨN CẤP',
  eis_q2_subtitle: 'Lên kế hoạch thực hiện',
  eis_q2_short: 'Quan trọng, không khẩn',
  eis_q3_title: 'Q3 — KHÔNG QUAN TRỌNG VÀ KHÔNG KHẨN CẤP',
  eis_q3_subtitle: 'Có thể loại bỏ hoặc làm sau',
  eis_q3_short: 'Không quan trọng, không khẩn',
  eis_q4_title: 'Q4 — KHÔNG QUAN TRỌNG NHƯNG KHẨN CẤP',
  eis_q4_subtitle: 'Ủy quyền hoặc làm nhanh',
  eis_q4_short: 'Không quan trọng, khẩn',
  eis_axis_x: 'MỨC ĐỘ KHẨN CẤP',
  eis_axis_y: 'MỨC ĐỘ QUAN TRỌNG',
};
